import {ACES, Roles} from "../components/admin/user/UserManager.types";
import {notification} from "antd";
import Language from "../language";

export const updateAces = async (
  aces: Pick<ACES, "target" | "roles">[],
  newFormData: { [p: string]: Roles[] | undefined },
  userId: number,
  updateUserAces: ({userId, aces}: { userId: any, aces: Pick<ACES, "target" | "roles">[] }) => Promise<void>,
  data?: { [p: string]: Roles[] | undefined },
) => {
  const previousRolesPerTarget: {
    [target: string]: Roles[]
  } | undefined = aces.reduce((acc, {target, roles}) => ({
    ...acc,
    [target]: roles,
  }), {})

  const newAcesFiltered = Object.entries({...data, ...newFormData})
    .reduce((acc: {
      target: string,
      roles: Roles[]
    }[], [target, roles]) => [
      ...acc,
      {
        target,
        roles: roles || [],
      },
    ], [])
    .filter(Boolean)
    // remove entry for a target when no role previously exists and none is newly selected
    .filter(({target, roles}) => roles.length > 0 || previousRolesPerTarget?.[target])
  await updateUserAces({
    userId,
    aces: newAcesFiltered,
  }).then(() => {
    notification.info({
      message: Language.get('saved-action'),
      placement: 'bottomRight',
      duration: 2.5,
    })
  })
}